/** @jsxImportSource @emotion/react */

import { getLayoutData } from '@backend/layoutData';
import { isStoreCode } from '@common/typeCheckers';
import OrderTrackingLP from '@stories/templates/OrderTracking/OrderTrackingLP';
import { setCacheHeaderForSSR, setupRequests } from '@utils/helpers';
import { getChildRequestLogger } from '@utils/logger';
import Layout from 'src/components/layout';

import type { NextPageWithLayout } from '../_app';
import type { GetServerSideProps } from 'next';
import type { LayoutProps } from 'src/components/layout';

type OrderTrackingPageParams = { store: string; categoryId: string };
type OrderTrackingPageState = LayoutProps;

setupRequests();

export const getServerSideProps: GetServerSideProps<OrderTrackingPageState, OrderTrackingPageParams> = async (
  context
) => {
  const { req, res, params, query, preview } = context;
  const log = getChildRequestLogger(req, params, query);
  const { store: storeCode } = params || {};

  if (!storeCode || !isStoreCode(storeCode)) {
    log.error('Invalid params: store');
    throw new Error('Invalid params: store');
  }

  // Cache this page only if this is not a preview
  if (!preview) {
    setCacheHeaderForSSR(res);
  }

  try {
    const layoutProps = await getLayoutData({
      context,
      storeCode,
      pagePath: '/order_tracking',
      pageType: 'product',
      pageMeta: {
        title: 'OrderTracking',
        metaDescription: 'OrderTracking',
        metaTitle: 'OrderTracking',
        metaKeywords: null,
        metaRobots: 'INDEX,FOLLOW'
      }
    });

    return {
      props: {
        ...layoutProps
      }
    };
  } catch (error) {
    log.error(error);
    // Render 500 page
    throw error;
  }
};

const OrderTrackingLandingPage: NextPageWithLayout<OrderTrackingPageState> = () => {
  return (
    <>
      <OrderTrackingLP />
    </>
  );
};

OrderTrackingLandingPage.getLayout = function getLayout(page, pageProps) {
  return <Layout {...pageProps}>{page}</Layout>;
};

export default OrderTrackingLandingPage;
